import React from "react";
import css from "./BlogView.module.css";
import {SectionView} from "Components";


export default function BlogView(props={}){
    const {sections,titleSize}=props;
    return (
        <article className={`${css.blogview} ${props.className||""}`} style={props.style}>
            {sections?.map((section,i)=>(
                <SectionView 
                    titleSize={titleSize} {...section}
                    key={section.title||i} 
                    className={css.section}
                />
            ))}
            {props.children}
        </article>
    )
}